import signedFetch from './util/signedFetch.js';

export default function* getWordOfTheDayRequestApi() {
  return yield signedFetch('getWordOfTheDayRequest', `${__API_BASE__}/dictionary/wordoftheday`, 'GET');
}
